import styled from "styled-components"

export const Grid = styled.div`
  display: grid;
  gap: 3.5rem 2.5rem;
  margin-bottom: 4.5rem;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const Card = styled.article`
  display: flex;
  flex-direction: column;
`

export const Media = styled.div`
  padding: 2rem 1.5rem;
  border-radius: var(--radius);
  .gatsby-image-wrapper {
    max-width: 440px;
    margin: 0 auto;
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding-top: 1.5rem;
  h3 {
    margin-bottom: 0.25rem;
  }
`

export const Role = styled.p`
  margin: 0 0 1rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--muted);
`

export const Result = styled.p`
  margin: 0 0 1rem;
  padding: 0.15rem 0 0.15rem 1rem;
  border-left: 3px solid var(--navy);
`

export const Tags = styled.p`
  margin: 0 0 1rem;
  font-size: 0.9375rem;
  color: var(--muted);
`

export const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.25rem;
  margin-top: auto;
  a {
    font-weight: 600;
  }
`

export const MoreTitle = styled.h3`
  margin-bottom: 1rem;
`

export const MoreList = styled.ul`
  margin: 0 0 3rem;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--line-strong);
  li {
    display: grid;
    gap: 0.25rem 2.5rem;
    margin: 0;
    padding: 1.25rem 0;
    border-bottom: 1px solid var(--line);
    @media (min-width: 768px) {
      grid-template-columns: minmax(0, 4fr) minmax(0, 8fr);
    }
  }
  h4 {
    margin: 0 0 0.15rem;
  }
  ${Role} {
    margin: 0;
    font-size: 0.9rem;
  }
  p {
    margin: 0 0 0.5rem;
    color: var(--muted);
  }
  ${Links} {
    margin-top: 0;
    a {
      font-size: 0.95rem;
    }
  }
`

export const Note = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 2rem;
  border-radius: var(--radius);
  background: var(--wash);
  h3 {
    margin-bottom: 0.35rem;
    font-size: 1.35rem;
  }
  p {
    margin: 0;
    max-width: 70ch;
    color: var(--muted);
  }
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    padding: 2.5rem;
    > a {
      flex: 0 0 auto;
    }
  }
`
